import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BenefitsPlusRoutingModule } from './benefits-plus-routing.module';
import { BenefitsPlusComponent } from './components/benefits-plus/benefits-plus.component';
import { BenefitsPopUpComponent } from './components/benefits-pop-up/benefits-pop-up.component';
import { LobbyComponent } from './components/lobby/lobby.component';
import { BenefitsPlusService } from './services/benefits-plus.service'
import { CardholdersCoreModule } from '../../shared/cardholders-core/cardholders-core.module';
import { AllBenefitsComponent } from './components/all-benefits/all-benefits.component';
import { PromotedBenefitsComponent } from './components/promoted-benefits/promoted-benefits.component';
import { BenefitsPlusFiltersComponent } from './components/benefits-plus-filters/benefits-plus-filters.component';


@NgModule({
  declarations: [
    BenefitsPopUpComponent,
    BenefitsPlusComponent,
    LobbyComponent,
    AllBenefitsComponent,
    PromotedBenefitsComponent,
    BenefitsPlusFiltersComponent
  ],
  imports: [
    CommonModule,
    BenefitsPlusRoutingModule,
    CardholdersCoreModule
  ],
  providers: [
      BenefitsPlusService
  ]
})
export class BenefitsPlusModule { }
